import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import React, { Suspense, lazy } from "react";
const ContactUsPage = lazy(() => import("./components/ContactUsPage.jsx"));
import HomePageNew from "./pages/HomePage.jsx";
const CookiespolicyPage = lazy(
  () => import("./components/CookiespolicyPage.jsx"),
);
const TermsConditionsPage = lazy(
  () => import("./components/TermsConditionsPage.jsx"),
);
const PrivacypolicyPage = lazy(
  () => import("./components/PrivacypolicyPage.jsx"),
);
const Layout = lazy(() => import("./pages/Layout.jsx"));
const Signup = lazy(() => import("./pages/Signup.jsx"));
const LoginComp = lazy(() => import("./components/LoginComp.jsx"));
const AccountDeletion = lazy(() => import("./pages/AccountDeletion.jsx"));
const Pricing = lazy(() => import("./pages/Pricing.jsx"));
const HowtousePage = lazy(() => import("./pages/HowtousePage.jsx"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess.jsx"));
const PaymentCancel = lazy(() => import("./pages/PaymentCancel.jsx"));

const PayrollWebApp = lazy(() => import("./components/HRMSSoftware.jsx"));

const SelfieAttendance = lazy(
  () => import("./components/SelfieAttendance.jsx"),
);
const LiveLocationTracking = lazy(
  () => import("./components/LiveLocationTracking.jsx"),
);

const PayrollManagement = lazy(() => import("./pages/PayrollManagement.jsx"));
const AttendanceManagement = lazy(
  () => import("./pages/AttendanceManagement.jsx"),
);
const ShiftManagement = lazy(() => import("./pages/ShiftManagement.jsx"));
const LeaveManagement = lazy(() => import("./pages/LeaveManagement.jsx"));
const TaskManagement = lazy(() => import("./pages/TaskManagement.jsx"));
const GeoLocationAttendance = lazy(
  () => import("./pages/GeoLocationAttendance.jsx"),
);
const SelfieBasedAttendance = lazy(
  () => import("./pages/SelfieBasedAttendance.jsx"),
);
const ReminderManagement = lazy(() => import("./pages/ReminderManagement.jsx"));
const TaxFormsManagement = lazy(() => import("./pages/TaxFormsManagement.jsx"));

const OurFeature = lazy(() => import("./components/OurFeature.jsx"));
const AboutUs = lazy(() => import("./components/AboutUs.jsx"));
const PageNotFound = lazy(() => import("./pages/PageNotFound.jsx"));
const Hiring = lazy(() => import("./components/Hiring.jsx"));
const ReferralSystem = lazy(() => import("./components/ReferralSystem.jsx"));
const RefferalSystemPage = lazy(
  () => import("./components/RefferalSystemPage.jsx"),
);
const BecomeInvestor = lazy(() => import("./components/BecomeInvestor.jsx"));
const BecomePartner = lazy(() => import("./components/BecomePartner.jsx"));
const NewDelhi = lazy(() => import("./components/Citywise/NewDelhi.jsx"));
const Mumbai = lazy(() => import("./components/Citywise/Mumbai.jsx"));
const Bangalore = lazy(() => import("./components/Citywise/Bangalore.jsx"));
const Hyderabad = lazy(() => import("./components/Citywise/Hyderabad.jsx"));
const Chennai = lazy(() => import("./components/Citywise/Chennai.jsx"));
const ThankYouContact = lazy(
  () => import("./components/thankyou/ThankYouContact.jsx"),
);
const ThankuHero = lazy(() => import("./components/thankyou/ThankuHero.jsx"));
const ThankYouDemo = lazy(
  () => import("./components/thankyou/ThankYouDemo.jsx"),
);
const RefundPolicyPage = lazy(
  () => import("./components/RefundPolicyPage.jsx"),
);
const Gurgaon = lazy(() => import("./components/Citywise/Gurgaon.jsx"));
const Noida = lazy(() => import("./components/Citywise/Noida.jsx"));
const Mohali = lazy(() => import("./components/Citywise/Mohali.jsx"));
const ProfileSettings = lazy(() => import("./pages/ProfileSettings.jsx"));
const CompanyAnnouncement = lazy(
  () => import("./pages/CompanyAnnouncement.jsx"),
);
const Chandigarh = lazy(() => import("./components/Citywise/Chandigarh.jsx"));
const BonusManagement = lazy(() => import("./pages/BonusManagement.jsx"));
const IncentiveManagement = lazy(
  () => import("./pages/IncentiveManagement.jsx"),
);
const OvertimeManagement = lazy(() => import("./pages/OvertimeManagement.jsx"));
const ExpenseManagement = lazy(() => import("./pages/ExpenseManagement.jsx"));
const AllFeaturesPage = lazy(() => import("./components/AllFeaturesPage.jsx"));
const LoanAndAdvance = lazy(() => import("./pages/LoanAndAdvance.jsx"));
const FaceRecognitionAttendance = lazy(
  () => import("./pages/FaceRecognitionAttendance.jsx"),
);
const LayoutDocuments = lazy(() => import("./pages/LayoutDocuments.jsx"));
const PayslipGenerator = lazy(
  () => import("./components/payslip/PayslipGenerator.jsx"),
);
const InvoiceGenerator = lazy(
  () => import("./components/payslip/InvoiceGenerator.jsx"),
);
const OfferLetterGenerator = lazy(
  () => import("./components/letters/OfferLetterGenerator.jsx"),
);
const AppointmentLetterGenerator = lazy(
  () => import("./components/letters/AppointmentLetterGenerator.jsx"),
);
const ExperienceLetterGenerator = lazy(
  () => import("./components/letters/ExperienceLetterGenerator.jsx"),
);
const RelievingLetterGenerator = lazy(
  () => import("./components/letters/RelievingLetterGenerator.jsx"),
);
const PromotionLetterGenerator = lazy(
  () => import("./components/letters/PromotionLetterGenerator.jsx"),
);
const SalaryIncrementLetterGenerator = lazy(
  () => import("./components/letters/SalaryIncrementLetterGenerator.jsx"),
);
const SalaryRevisionLetterGenerator = lazy(
  () => import("./components/letters/SalaryRevisionLetterGenerator.jsx"),
);
const Itcompanies = lazy(
  () => import("./components/IndustryPages/Itcompanies.jsx"),
);
const AllLetters = lazy(() => import("./components/letters/AllLetters.jsx"));
const FaceLens = lazy(() => import("./components/FaceLens.jsx"));
const StaffAttendanceApp = lazy(
  () => import("./components/StaffAttendanceApp.jsx"),
);
const ConfirmationLetterGenerator = lazy(
  () => import("./components/letters/ConfirmationLetterGenerator.jsx"),
);
const WarningLetterGenerator = lazy(
  () => import("./components/letters/WarningLetterGenerator.jsx"),
);
const ShowCauseNoticeLetterGenerator = lazy(
  () => import("./components/letters/ShowCauseNoticeLetterGenerator.jsx"),
);
const TerminationLetterGenerator = lazy(
  () => import("./components/letters/TerminationLetterGenerator.jsx"),
);
// Keep this NOT lazy (important for UX)
// import ScrollToTop from "./components/ScrollToTop.jsx";
// import Waggexvskekka from "./components/comparepages/waggexvskekka/Waggexvskekka.jsx";
// import NewDelhi from "./components/Citywise/NewDelhi.jsx";
// import Mumbai from "./components/Citywise/Mumbai.jsx";
// import Bangalore from "./components/Citywise/Bangalore.jsx";
// import Hyderabad from "./components/Citywise/Hyderabad.jsx";
// import Chennai from "./components/Citywise/Chennai.jsx";
// import ThankYouContact from "./components/thankyou/ThankYouContact.jsx";
// import ThankuHero from "./components/thankyou/ThankuHero.jsx";
// import ThankYouDemo from "./components/thankyou/ThankYouDemo.jsx";
// import RefundPolicyPage from "./components/RefundPolicyPage.jsx";
// import Gurgaon from "./components/Citywise/Gurgaon.jsx";
// import Noida from "./components/Citywise/Noida.jsx";
// import Mohali from "./components/Citywise/Mohali.jsx";
// import ProfileSettings from "./pages/ProfileSettings.jsx";
// import CompanyAnnouncement from "./pages/CompanyAnnouncement.jsx";
// import Chandigarh from "./components/Citywise/Chandigarh.jsx";
// import BonusManagement from "./pages/BonusManagement.jsx";
// import IncentiveManagement from "./pages/IncentiveManagement.jsx";
// import OvertimeManagement from "./pages/OvertimeManagement.jsx";
// import ExpenseManagement from "./pages/ExpenseManagement.jsx";
// import AllFeaturesPage from "./components/AllFeaturesPage.jsx";
// import LoanAndAdvance from "./pages/LoanAndAdvance.jsx";
// import FaceRecognitionAttendance from "./pages/FaceRecognitionAttendance.jsx";
// import LayoutDocuments from "./pages/LayoutDocuments.jsx";
// import PayslipGenerator from "./components/payslip/PayslipGenerator.jsx";
// import InvoiceGenerator from "./components/payslip/InvoiceGenerator.jsx";
// import OfferLetterGenerator from "./components/letters/OfferLetterGenerator.jsx";
// import AppointmentLetterGenerator from "./components/letters/AppointmentLetterGenerator.jsx";
// import ExperienceLetterGenerator from "./components/letters/ExperienceLetterGenerator.jsx";
// import RelievingLetterGenerator from "./components/letters/RelievingLetterGenerator.jsx";
// import PromotionLetterGenerator from "./components/letters/PromotionLetterGenerator.jsx";
// import SalaryIncrementLetterGenerator from "./components/letters/SalaryIncrementLetterGenerator.jsx";
// import SalaryRevisionLetterGenerator from "./components/letters/SalaryRevisionLetterGenerator.jsx";
// import Itcompanies from "./components/IndustryPages/Itcompanies.jsx";
// import AllLetters from "./components/letters/AllLetters.jsx";
// import FaceLens from "./components/FaceLens.jsx";
// import StaffAttendanceApp from "./components/StaffAttendanceApp.jsx";
// import ConfirmationLetterGenerator from "./components/letters/ConfirmationLetterGenerator.jsx";
// import WarningLetterGenerator from "./components/letters/WarningLetterGenerator.jsx";
// import ShowCauseNoticeLetterGenerator from "./components/letters/ShowCauseNoticeLetterGenerator.jsx";
// import TerminationLetterGenerator from "./components/letters/TerminationLetterGenerator.jsx";
// // fff
export default function App() {
  return (
    <>
      <Suspense
        fallback={
          <div className="fixed inset-0 z-1000 bg-[#d0e1f5] backdrop-blur-sm flex items-center justify-center">
            <div className="flex flex-col items-center justify-center p-4 sm:p-6 md:p-8 w-full sm:max-w-3xl text-center">
              <div
                className="border-4 border-[#9BBBE0] border-t-transparent rounded-full animate-spin
                        w-24 h-24 sm:w-50 sm:h-50"
              />
              <p className="text-[#01324F] font-medium text-xl sm:text-2xl mt-4">
                Please wait while we prepare the best experience for you
              </p>
            </div>
          </div>
        }
      >
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePageNew />} />
            <Route path="/home" element={<HomePageNew />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/cookies-policy" element={<CookiespolicyPage />} />
            <Route path="/terms-conditions" element={<TermsConditionsPage />} />
            <Route path="/privacy-policy" element={<PrivacypolicyPage />} />
            {/* <Route path="/features" element={<OurFeature />} /> */}
            <Route path="/pricing" element={<Pricing />} />
            {/* <Route path="/login" element={<LoginComp />} />
              <Route path="/signup" element={<Signup />} /> */}
            <Route path="/account-deletion" element={<AccountDeletion />} />
            <Route path="/how-to-use" element={<HowtousePage />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/hrms-software" element={<PayrollWebApp />} />
            {/* <Route path="/payroll-web-app" element={<PayrollWebApp />} /> */}
            <Route path="/facelens-app" element={<FaceLens />} />
            <Route path="/payroll-management" element={<PayrollManagement />} />
            <Route
              path="/attendance-management"
              element={<AttendanceManagement />}
            />
            <Route path="/shift-management" element={<ShiftManagement />} />
            <Route
              path="/staff-attendance-app"
              element={<StaffAttendanceApp />}
            />
            <Route path="/leave-management" element={<LeaveManagement />} />
            <Route path="/task-management" element={<TaskManagement />} />
            <Route path="/thank-you" element={<ThankuHero />} />
            <Route path="/thank-you-contact" element={<ThankYouContact />} />
            <Route path="/thank-you-demo" element={<ThankYouDemo />} />
            <Route
              path="/refund-and-cancellation"
              element={<RefundPolicyPage />}
            />
            <Route
              path="/geo-location-attendance"
              element={<GeoLocationAttendance />}
            />
            <Route path="/all-features" element={<AllFeaturesPage />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route
              path="/company-announcements"
              element={<CompanyAnnouncement />}
            />
            <Route path="/it-companies" element={<Itcompanies />} />
            <Route path="/employee-bonus" element={<BonusManagement />} />
            <Route
              path="/loan-advance-management"
              element={<LoanAndAdvance />}
            />
            <Route
              path="/face-recognition-attendance"
              element={<FaceRecognitionAttendance />}
            />

            <Route
              path="/incentive-management"
              element={<IncentiveManagement />}
            />
            <Route
              path="/overtime-management"
              element={<OvertimeManagement />}
            />
            <Route path="/expense-management" element={<ExpenseManagement />} />
            <Route
              path="/face-recognition-attendance-system"
              element={<SelfieAttendance />}
            />

            {/* Old URL → New URL */}
            <Route
              path="/selfie-attendance"
              element={
                <Navigate to="/face-recognition-attendance-system" replace />
              }
            />
            <Route
              path="/employee-location-tracking-software"
              element={<LiveLocationTracking />}
            />
            <Route
              path="/selfie-based-attendance"
              element={<SelfieBasedAttendance />}
            />
            <Route
              path="/reminder-management"
              element={<ReminderManagement />}
            />
            <Route
              path="/tax-form-management"
              element={<TaxFormsManagement />}
            />
            <Route
              path="/best-payroll-software-in-delhi"
              element={<NewDelhi />}
            />
            <Route
              path="/best-payroll-software-in-Mohali"
              element={<Mohali />}
            />
            <Route path="/best-payroll-software-in-noida" element={<Noida />} />
            <Route
              path="/best-payroll-software-in-mumbai"
              element={<Mumbai />}
            />
            <Route
              path="/best-payroll-software-in-bangalore"
              element={<Bangalore />}
            />
            <Route
              path="/best-payroll-software-in-Hyderabad"
              element={<Hyderabad />}
            />
            <Route
              path="/best-payroll-software-in-chennai"
              element={<Chennai />}
            />
            <Route
              path="/best-payroll-software-in-gurgaon"
              element={<Gurgaon />}
            />
            <Route
              path="/best-payroll-software-in-chandigarh"
              element={<Chandigarh />}
            />
            <Route path="/all-hr-documents" element={<AllLetters />} />
            {/* <Route path="/waggex-vs-kekka" element={<Waggexvskekka />} /> */}
            <Route path="/become-partner" element={<BecomePartner />} />
            <Route path="/become-investor" element={<BecomeInvestor />} />
            <Route path="/referral-system" element={<RefferalSystemPage />} />
            <Route path="/hiring" element={<Hiring />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>

          <Route element={<LayoutDocuments />}>
            <Route
              path="/hr-documents/payslip-generator"
              element={<PayslipGenerator />}
            />
            <Route
              path="/hr-documents/offer-letter-generator"
              element={<OfferLetterGenerator />}
            />
            <Route
              path="/hr-documents/experience-letter-generator"
              element={<ExperienceLetterGenerator />}
            />
            <Route
              path="/hr-documents/appointment-letter-generator"
              element={<AppointmentLetterGenerator />}
            />
            <Route
              path="/hr-documents/relieving-letter-generator"
              element={<RelievingLetterGenerator />}
            />
            <Route
              path="/hr-documents/salaryincrement-letter-generator"
              element={<SalaryIncrementLetterGenerator />}
            />

            <Route
              path="/hr-documents/promotion-letter-generator"
              element={<PromotionLetterGenerator />}
            />

            <Route
              path="/hr-documents/salaryrevision-letter-generator"
              element={<SalaryRevisionLetterGenerator />}
            />
            <Route
              path="/hr-documents/confirmation-letter-generator"
              element={<ConfirmationLetterGenerator />}
            />
            <Route
              path="/hr-documents/warning-letter-generator"
              element={<WarningLetterGenerator />}
            />
            <Route
              path="/hr-documents/show-cause-notice-letter-generator"
              element={<ShowCauseNoticeLetterGenerator />}
            />
            <Route
              path="/hr-documents/termination-letter-generator"
              element={<TerminationLetterGenerator />}
            />
            {/*
            <Route path="/gst-calculator" element={<GSTCalculator />} />

            <Route
              path="/gst-invoice-generator"
              element={<GSTInvoiceGenerator />}
            />

            <Route
              path="/expense-reimbursement-form"
              element={<ExpenseReimbursementForm />}
            />

            <Route
              path="/employee-id-card-generator"
              element={<EmployeeIDCardGenerator />}
            />

            <Route
              path="/salary-slip-generator"
              element={<SalarySlipGenerator />}
            />

            <Route
              path="/bank-transfer-sheet-generator"
              element={<BankTransferSheetGenerator />}
            />

            <Route
              path="/joining-checklist-generator"
              element={<JoiningChecklistGenerator />}
            />

            <Route
              path="/exit-checklist-generator"
              element={<ExitChecklistGenerator />}
            /> */}
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
